export default __webpack_public_path__ + "static/media/wifi.addc5704.svg";